export default __webpack_public_path__ + "static/media/BosaImportants1.a532d827.JPG";